/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {upsertTodo} from '../api'

export const useMutationUpsertTodo = createReactQueryMutationHook('upsertTodo', upsertTodo)
